import { ChartColumn } from "lucide-react";
import * as React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import Grid from "@mui/material/Grid";
import { theme } from "@src/theme";

interface NoDataOverlayProps {
  message1: string;
  message2?: string;
}

export const NoDataOverlay: React.FC<NoDataOverlayProps> = ({
  message1,
  message2,
}: NoDataOverlayProps) => {
  return (
    <Grid
      container
      direction={"column"}
      alignItems={"center"}
      alignContent={"center"}
      justifyContent={"center"}
      textAlign={"center"}
    >
      <Grid>
        <ChartColumn size={50} />
      </Grid>
      <Grid>
        <IgTypography>{message1}</IgTypography>
      </Grid>
      <Grid>
        <IgTypography>{message2}</IgTypography>
      </Grid>
    </Grid>
  );
};
